export enum UniversityFeatureFlags {
    STAFF_PROFILES = "staffProfiles",
    COLLECT_DOMESTIC_REGION_ON_SIGNUP = "collectDomesticRegionOnSignup",
    CUSTOM_LEVELS_ENABLED = "customLevelsEnabled",
}
